const termsOfServiceContent = `Terms and Conditions
Full Trucking Service

Effective Date: 14.03.2025

<h2>1. Introduction</h2>
Welcome to Full Trucking Service ("Company", "we", "our", "us"). These Terms and Conditions ("Terms") define the legal agreement between users and our company regarding the use of our software services.

<h3>1.1 Purpose</h3>
The purpose of these Terms is to clarify the rights, responsibilities, and obligations of all users of our platform.
By defining these rules, we ensure that the Full Trucking Service software is used in a secure and efficient manner by all parties involved.
These Terms aim to protect both the users and the company by preventing any misuse, fraudulent activity, or illegal behavior.


<h3>1.2 Acceptance of Terms</h3>
By creating an account and using our software, you explicitly agree to abide by these Terms.
If you do not agree with any part of these Terms, you must immediately stop using the service and request the closure of your account.
We reserve the right to update these Terms at any time, and users will be notified of significant changes via email.


<h2>2. Services Provided </h2>

<h3>2.1 Accounting & Payroll</h3>
Our software automates payroll processing for truck drivers, dispatchers, and accountants, ensuring that payments are accurately calculated based on work hours, miles driven, and other performance metrics.
Users can generate detailed payroll reports, calculate tax deductions, and store financial records securely.
Payroll automation helps businesses avoid manual errors and compliance issues with tax regulations.

<h3>2.2 Load Management</h3>
The system allows users to track, schedule, and manage freight loads in real-time.
Users can assign loads to drivers, generate invoices, and update shipment statuses instantly.
The software ensures that load data is stored securely and is accessible anytime, reducing paperwork and manual record-keeping.


<h3>2.3 Dispatching & Route Optimization</h3>
Intelligent dispatching tools ensure that the right driver is assigned to the right load based on availability and efficiency.
Our platform provides automated route optimization, helping companies save on fuel costs and delivery time.
The system tracks real-time GPS location data to improve delivery estimates and reduce delays.


<h2>3. Subscription Plans</h2>

<h3>3.1 Available Tiers</h3>
Statement Plan: Ideal for independent truckers who need basic payroll management without additional load tracking or dispatching features.
Basic Plan: Designed for small trucking businesses that require payroll processing, basic load management, and limited dispatching tools.
Standard Plan: Includes full accounting, payroll, load management, and dispatching tools for mid-sized trucking companies.
Premium Plan: Adds advanced reporting, analytics, and integrations with third-party logistics systems.
Ultimate Plan: The most comprehensive plan, offering 24/7 customer support, unlimited users, and full API access.
Custom Plan: Tailored solutions built according to the client’s specific needs, including custom dashboard design, API development, and specialized integrations.

<h2>4. Registration & Account Setup<h2>

<h3>4.1 Required Information</h3>
To register for Full Trucking Service, users must provide:
Company Name & Address
Owner’s Full Name & Role
Valid Email Address & Phone Number
MC Number & DOT Registration (if applicable)
Number of Dispatchers, Accountants, and Drivers


<h3>4.2 Verification Process</h3>
All new accounts go through a manual verification process to prevent fraud.
Users must provide valid documentation, such as a business license or DOT registration, for approval.
If fraudulent information is detected, the account will be denied and permanently blacklisted.


<h2>5. Free Trial & Activation</h2>

<h3>5.1 Trial Period</h3>
New users are eligible for a 14-day free trial that allows access to most features.
During the trial, users can explore payroll, dispatching, and load tracking tools before committing to a paid subscription.+

<h3>5.2 Activation</h3>
Accounts are activated only after successful verification and acceptance of these Terms.
If a user does not continue with a subscription, all trial data is permanently deleted.


<h2>6. Payment & Billing</h2>

<h3>6.1 Accepted Payment Methods</h3>
Full Trucking Service accepts Credit Card, IBAN, PayPal, and Wire Transfers for subscription payments.
Payments are processed through secure, encrypted transactions to protect user financial information.

<h3>6.2 Subscription Renewals</h3>
Monthly subscriptions automatically renew unless canceled before the renewal date.
Annual subscriptions offer discounts but are only refundable within the first 14 days.


<h2>7. Refund Policy</h2>

<h3>7.1 Refund Eligibility</h3>
Refunds are granted in the following cases:
A billing error resulted in an overcharge.
The user canceled within the 14-day refund window for annual plans.
The platform was unavailable for more than 72 consecutive hours due to system failure.

<h3>7.2 Refund Process</h3>
Users must submit a written refund request via email.
Refunds are processed within 14 business days to the original payment method.


<h2>8. Data Privacy & Security</h2>

<h3>8.1 Data Protection</h3>
Full Trucking Service employs bank-grade encryption to protect user data from unauthorized access.
We do not sell or share personal or business data with third-party advertisers.
Our servers are protected by firewalls and intrusion detection systems to prevent cyberattacks.

<h3>8.2 Account Deletion</h3>
Users may request permanent deletion of their account at any time.
All personal and business-related data is erased upon deletion, except for minimal records required for tax and compliance purposes.


<h2>9. Customer Support</h2>

<h3>9.1 Contact Options</h3>
Users can reach support via phone, email, or live chat for technical or billing assistance.
Premium and Ultimate users receive priority support and a dedicated account manager.


<h2>10. User Responsibilities</h2>

<h3>10.1 Ethical Usage</h3>
Users must not engage in fraudulent, deceptive, or illegal activities on the platform.
Misuse of the service, such as falsifying trip records, will result in immediate suspension.

<h3>10.2 Security Measures</h3>
Users must not share their login credentials with unauthorized individuals.
Any suspected security breach must be reported immediately to prevent account compromise.


<h2>11. Intellectual Property Rights</h2>

<h3>11.1 Ownership</h3>
All software, trademarks, branding, and documentation associated with Full Trucking Service are 100% owned by the company.
Users are granted a limited, non-transferable license to use the software for their business operations, but they do not acquire ownership rights over the platform.

<h3>11.2 Copyright Violations</h3>
Users cannot copy, modify, distribute, or reverse-engineer any part of the software without prior written permission from Full Trucking Service.
Any unauthorized use of company assets will lead to immediate legal action and possible monetary damages.


<h2>12. Limitation of Liability</h2>

<h3>12.1 Disclaimer</h3>
Full Trucking Service is not responsible for:
Business losses due to user errors, incorrect payroll data, or incomplete dispatch records.
Financial damages resulting from third-party service failures (e.g., payment processors, GPS tracking tools).

<h3>12.2 Service Interruptions</h3>
While we strive for 99.9% uptime, scheduled maintenance or unforeseen outages may occur.
Users acknowledge that occasional service interruptions do not qualify for refunds or compensation unless explicitly stated in a contract.


<h2>13. Governing Law & Dispute Resolution</h2>

<h3>13.1 Jurisdiction</h3>
These Terms are governed under U.S. law, and any legal disputes will be handled within the United States.
International users must comply with local regulations but agree that any disputes will be settled in a U.S. court of law.

<h3>13.2 Arbitration</h3>
In case of legal disputes, users must attempt arbitration before proceeding with litigation.
Arbitration will be handled by an independent legal mediator, and both parties must respect the final decision.


<h2>14. Modifications to Terms</h2>

<h3>14.1 Updates</h3>
Full Trucking Service reserves the right to modify these Terms at any time.
Major changes will be communicated via email and must be accepted by users before continuing use of the platform.


<h2>15. Account Termination</h2>

<h3>15.1 Termination Policy</h3>
Accounts may be suspended or permanently banned if users:
Violate these Terms through fraudulent or abusive behavior.
Attempt to hack, manipulate, or exploit the system.
Fail to comply with payment obligations for an extended period.
Once an account is terminated, all associated data will be permanently erased.


<h2>16. Force Majeure</h2>

<h3>16.1 Service Disruptions</h3>
Full Trucking Service is not responsible for delays or service disruptions caused by events beyond our control, including:
Natural disasters (earthquakes, hurricanes, floods).
Government regulations or legal restrictions.
Cyberattacks or major system failures affecting the internet infrastructure.


<h2>17. Third-Party Services</h2>

<h3>17.1 Integrations</h3>
Some features of Full Trucking Service rely on third-party tools, such as:
Payment processors (e.g., PayPal, Stripe).
GPS tracking services for real-time fleet monitoring.
Full Trucking Service is not liable for service failures or security breaches originating from third-party providers.


<h2>18. API Usage</h2>

<h3>18.1 API Access</h3>
Businesses that wish to integrate their own systems with Full Trucking Service API must:
Submit a formal request for access.
Agree to follow API security policies and rate limits.
Accept that abuse of the API (e.g., sending excessive requests) will result in access restrictions.


<h2>19. Marketing & Promotions</h2>

<h3>19.1 Branding</h3>
Users agree that Full Trucking Service may display their company name and logo in marketing materials unless they opt out in writing.
Promotional offers or discounts may be limited in availability and subject to expiration dates.


<h2>20. Communication Preferences</h2>

<h3>20.1 Notifications</h3>
Users must provide a valid email for receiving:
Billing invoices & subscription updates.
Important security alerts (e.g., password reset requests).
Marketing emails can be disabled in account settings, but critical notifications cannot be turned off.


<h2>21. Fair Use Policy</h2>

<h3>21.1 Misuse Prevention</h3>
To maintain platform performance, users must not:
Generate excessive API requests that slow down services.
Exploit the system for unauthorized commercial activities.
Attempt to overload the system using automation or bots.


<h2>22. Compliance with Laws</h2>

<h3>22.1 Legal Responsibilities</h3>
Users must comply with all applicable laws in their country regarding:
Tax reporting for payroll and financial transactions.
Employment regulations for truck drivers and dispatchers.
Data protection laws governing personal information storage.


<h2>23. Account Recovery</h2>

<h3>23.1 Lost Credentials</h3>
If a user loses their login credentials, they must:
Submit a recovery request through email or phone verification.
Provide a security code sent to their registered email.
Answer security questions to prove their identity.


<h2>24. International Usage</h2>

<h3>24.1 Cross-Border Use</h3>
Full Trucking Service is primarily designed for trucking businesses in the United States, Canada, and South America.
Some features may not be available in other regions due to legal restrictions.


<h2>25. Customer Disputes</h2>

<h3>25.1 Complaint Handling</h3>
Users who have billing disputes or technical complaints must:
First contact customer support and attempt to resolve the issue.
If unresolved, escalate the matter through our formal dispute resolution team.


<h2>26. Data Breach Policy</h2>

<h3>26.1 Security Notifications</h3>
If Full Trucking Service experiences a data breach, users will be notified within 72 hours.
Affected accounts may be temporarily disabled to prevent further risk.


<h2>27. Feature Requests</h2>

<h3>27.1 Customization</h3>
Businesses that require new features or system modifications can submit a feature request.
Approved feature requests may take several months to develop and implement.


<h2>28. Compliance Audits</h2>

<h3>28.1 Regulatory Compliance</h3>
Full Trucking Service reserves the right to conduct audits of user accounts to ensure compliance with tax laws, security standards, and platform policies.


<h2>29. Reseller & Affiliate Program</h2>

<h3>29.1 Partner Program</h3>
Approved partners may resell our services under an affiliate agreement.
Resellers must meet specific performance metrics to maintain eligibility.

<h2>30. Contact Information</h2>

<h3>30.1 Support Details</h3>
Users can contact customer support through:
Email: [support@fulltruckingservice.com]

`;

export default termsOfServiceContent;